const CACHE_TTL_MS = 30 * 60 * 1000;
const store = new Map();

function datePart(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

export function buildTrackingCacheKey(farmId, selection) {
  if (!selection) return "";
  const operatorIds = (selection.operatorIds || []).slice().sort().join(",");
  const equipmentIds = (selection.equipmentIds || []).slice().sort().join(",");
  const machineIdents = (selection.machineIdents || []).slice().sort().join(",");
  return [
    farmId,
    operatorIds,
    selection.allMachines ? "all" : "pick",
    equipmentIds,
    machineIdents,
    datePart(selection.dateFrom),
    datePart(selection.dateTo),
  ].join("|");
}

export function getCachedTracking(cacheKey) {
  if (!cacheKey) return null;
  const entry = store.get(cacheKey);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > CACHE_TTL_MS) {
    store.delete(cacheKey);
    return null;
  }
  return entry.data;
}

export function setCachedTracking(cacheKey, data) {
  if (!cacheKey || !data) return;
  store.set(cacheKey, {
    data,
    fetchedAt: Date.now(),
  });
}

export function clearCachedTracking(cacheKey) {
  if (!cacheKey) return;
  store.delete(cacheKey);
}

export function clearTrackingCacheForFarm(farmId) {
  if (!farmId) return;
  const prefix = `${farmId}|`;
  Array.from(store.keys()).forEach((key) => {
    if (key.startsWith(prefix)) {
      store.delete(key);
    }
  });
}

export function trackingCacheMeta(cacheKey) {
  const entry = store.get(cacheKey);
  if (!entry) return null;
  return {
    fetchedAt: entry.fetchedAt,
    ageMs: Date.now() - entry.fetchedAt,
  };
}
